let allCountries, countriesByRegion, provincesByCountry, allProvinces;
const MIN_CHARS_COUNTRIES_SEARCH = 2;

import * as d3 from "d3";
import { DateTime } from "luxon";
import { EARLIEST_DATA_DATE, PROVINCE_SEPARATOR, MAX_LOCATIONS_GRID_MODE } from "./constants";

// Modify display names and synonyms
let countriesConfig = {
  'USA' : {displayName:'United States', synonyms:['U.S.A.', 'America']},
  'UK'  : {displayName:'United Kingdom', synonyms:['U.K.']},
  'Réunion'  : {displayName:'Réunion', synonyms:['Reunion']}
}
let provincesConfig = {
  'D.C.' : {displayName:'Washington, D.C.', synonyms:['DC', 'District of Columbia', 'Washington DC']},
  'New York' : {displayName:'New York', synonyms:['NY']},
  'New Jersey' : {displayName:'New Jersey', synonyms:['NJ']},
  'Massachusetts' : {displayName:'Massachusetts', synonyms:['MA', 'Mass']},
  'Hawaii' : {displayName:'Hawaiʻi', synonyms:['HI']},
}

import geographyJson from './data/geography.json';

let countryCounts, provinceCounts;
let setCountry, getCountries, setCountries, changeGridMode; // callbacks

let isAddMode = false;

export function initCountries(_setCountry, _getCountries, _setCountries, _changeGridMode) {

  setCountry = _setCountry;
  getCountries = _getCountries;
  setCountries = _setCountries;
  changeGridMode = _changeGridMode;

  // Pre-fetch countries

  Promise.all([
    fetch(`https://wopr.fathom.info/datadict/country/`)
      .then(res => res.json())
      .then(data => {
        allCountries = processCountries(data.country);
      }),
    fetch(`https://wopr.fathom.info/datadict/province/`)
      .then(res => res.json())
      .then(data => {
        allProvinces = processProvinces(data.province);
      }),
    fetch(`https://wopr.fathom.info/query/bin=week,country/date=${ EARLIEST_DATA_DATE.toISODate() }:`)
      .then(res => res.json())
      .then(data => {
        countryCounts = data;
      }),

    // USA only for now
    fetch(`https://wopr.fathom.info/query/bin=week,province/country=USA/date=${ EARLIEST_DATA_DATE.toISODate() }:`)
      .then(res => res.json())
      .then(data => {
        provinceCounts = data;
      })
  ])
    .then(() => {

      // Initialize the default country
      let countries = getCountries();
      let parsedCountries = parseProvincesAndCountries(countries);

      updateSelectedCountry(parsedCountries[0], document.querySelector("#feature-country"));

      countriesByRegion = getCountriesByRegion(geographyJson.WorldGeography, allCountries);
      provincesByCountry = geographyJson.StateGeography;
      //console.log(provincesByCountry);

      tallyCountries(allCountries, countryCounts);
      tallyCountries(allProvinces, provinceCounts);

      // drawCountriesByRegion(countriesByRegion, allCountries);

      addEvents();
    })

}

function processCountries(countries) {

  countries = countries || [];

  countries = countries.filter(country => country.name !== '');
  countries = countries.map(country => {
    country.id = getCountryId(country.name);
    country = {...country, ...getCountryDetails(country.name)};
    return country;
  });

  return countries;

}

function processProvinces(provinces) {

  provinces = provinces || [];

  provinces = provinces.filter(province => province.name !== '');
  provinces = provinces.map(province => {
    province.id = getProvinceId(province.name);
    province = {...province, ...getProvinceDetails(province.name)};
    return province;
  });

  return provinces;

}

function tallyCountries(countries, counts) {

  let countryCounts = {};

  // let startDate = getStartDate();
  // let endDate = getEndDate();
  let countsKeyedByWeek = {};

  for (const date in counts.bins) {
    let countryBin = counts.bins[date];

    if (date !== '0000-00-00' && date.length === 10) {
      let weekDate = d3.timeWeek(DateTime.fromISO(date));
      weekDate = DateTime.fromJSDate(new Date(weekDate));

      countsKeyedByWeek[weekDate.toISODate()] = countsKeyedByWeek[weekDate.toISODate()] || {
        date : DateTime.fromISO(weekDate)
      };
      let weekBin = countsKeyedByWeek[weekDate.toISODate()];

      for (const country in countryBin) {

        weekBin[country] = weekBin[country] || {
          sequencesCount : 0
        }
        weekBin[country].sequencesCount += countryBin[country];

      }
    }
  }

  //console.log(counts);

  let countsByWeek = Object.values(countsKeyedByWeek);
  countsByWeek.sort((a, b) => a.date.diff(b.date));

  countries.forEach(country => {

    let mostRecentDataDate;
    countsByWeek.forEach(w => {
      if (w[country.name]) {
        mostRecentDataDate = w.date;
      }
    });

    if (!mostRecentDataDate) {
      return;
    }

    let startDate = mostRecentDataDate.minus({'months':4});
    let endDate = mostRecentDataDate;

    let filteredCountsByWeek = countsByWeek.filter(d => d.date >= startDate && d.date <= endDate);

    filteredCountsByWeek.forEach(week => {
      countryCounts[country.name] = countryCounts[country.name] || {sequencesCount:0};
      if (week[country.name]) {
        countryCounts[country.name].sequencesCount += week[country.name].sequencesCount;
      }
    });
  });


  countries.forEach(country => {
    country.sequencesCount = countryCounts[country.name] ? countryCounts[country.name].sequencesCount : 0;
  });

  //console.log(countries);
}

function getCountriesByRegion(countriesCategorized, countries) {

  let countriesRecategorized = {};

  for (const region in countriesCategorized) {

    countriesRecategorized[region] = {};

    for (const subRegion in countriesCategorized[region]) {

      let mappedCountries = [];

      countriesCategorized[region][subRegion].forEach(countryName => {

        let country = countries.find(c => c.name === countryName);
        //console.log(country, countryName);
        if (country) {
          mappedCountries.push(country);
        } else {
          //console.log(`could not find ${  countryName}`);
        }
      });

      countriesRecategorized[region][subRegion] = mappedCountries;
    }

  }
  return countriesRecategorized;
}

function addEvents() {
  document.querySelector("#feature-country").addEventListener("click", () => {
    toggleSearch();
  });

  document.querySelector("#feature-add-country").addEventListener("click", () => {
    toggleSearch(true);
  });

  document.querySelector("header").addEventListener("click", e => {

    if (document.body.classList.contains("search")) {

      // A click on the header on anything but a valid element toggles search
      if (document.querySelector("#feature-country").contains(e.srcElement)) {
        return;
      }
      if (document.querySelector("#feature-add-country").contains(e.srcElement)) {
        return;
      }
      if (document.querySelector("#actions").contains(e.srcElement)) {
        return;
      }
      if (document.querySelector("#identity").contains(e.srcElement)) {
        return;
      }

      toggleSearch();

    }

  });

  // let menu = document.querySelector("#feature-country .menu")
  // // dismiss.addEventListener("mouseenter", unhingeCountry);
  // // dismiss.addEventListener("mouseleave", hingeCountry);
  // menu.addEventListener("click", e => {
  //   e.stopPropagation();

  //   if (!document.body.classList.contains("search")) {
  //   toggleSearch();
  //   }
  //   dismissCountry();
  // });




  let countrySearchInputTimeout;
  document.querySelector("#search").addEventListener("input", () => {
    clearTimeout(countrySearchInputTimeout);
    let value = document.querySelector("#search").value;
    // Debounce
    if (value === '' || value.length >= MIN_CHARS_COUNTRIES_SEARCH) {
      countrySearchInputTimeout = setTimeout(() => searchCountries(value), 250);
    }
  });

  document.querySelector("#search-dismiss").addEventListener("click", () => {
    drawCountriesByRegion(countriesByRegion);
    document.querySelector("#search").value = '';
    document.querySelector("#search").focus();
    document.querySelector("#search-dismiss").classList.toggle("active", false);


  });

}

export function updateSelectedCountry(location, container) {

  let country = allCountries.find(c => c.id.toLowerCase() === location.countryId.toLowerCase());
  let province;
  if (location.isProvince) {
    province = allProvinces.find(c => c.id.toLowerCase() === location.provinceId.toLowerCase());
  }

  let displayName = getLocationDisplayName(location);

  //let feature = document.querySelector("#feature-country");
  let feature = container;

  // This is awkward, but there isn't a great way to use css classes for the country, and remove the last one
  let priorCountry = feature.getAttribute("data-country");
  feature.classList.toggle(priorCountry, false);
  let priorProvince = feature.getAttribute("data-province");
  if (priorProvince) {
    feature.classList.toggle(priorProvince, false);
  }

  feature.setAttribute("data-country", location.countryId);

  feature.classList.toggle(location.fullId, true);

  if (location.isProvince) {
    feature.setAttribute("data-province", location.provinceId);
  }

  if (location.isProvince && province) {
    feature.querySelector("h2").innerHTML = displayName;
  } else if (country) {
    feature.querySelector("h2").innerHTML = displayName;
  } else {
    feature.querySelector("h2").innerHTML = "Unknown country";
  }

}

export function getLocationDisplayName(location) {

  if (location.isProvince) {
    let province = allProvinces.find(c => c.id.toLowerCase() === location.provinceId.toLowerCase());
    return province.displayName;
  } else {
    let country = allCountries.find(c => c.id.toLowerCase() === location.countryId.toLowerCase());
    return country.displayName;
  }

}


export function toggleSearch(addLocation) {

  if (addLocation) {
    isAddMode = true;
  } else {
    isAddMode = false;
  }

  if ((document.body.classList.contains("search")) && (!document.body.classList.contains("empty"))) {
    document.body.classList.toggle("search", false);
  } else {
    document.body.classList.toggle("search", true);
    document.querySelector("#search").value = '';
    document.querySelector("#search").focus();
    drawCountriesByRegion(countriesByRegion, allCountries);
    searchCountries();
  }
}

// function unhingeCountry() {
//   let parent = document.querySelector("#feature-country");
//   if (!parent.classList.contains("unhinged")) {
//     parent.classList.toggle("unhinged", true);
//   }
// }

function hingeCountry() {
  let parent = document.querySelector("#feature-country");
  if (parent.classList.contains("unhinged")) {
    parent.classList.toggle("unhinged", false);
  }
}

// function dismissCountry() {
//   let page = document.querySelector("body");
//   if (!page.classList.contains("empty")) {
//     page.classList.toggle("empty", true);
//
//     document.querySelector("#feature-details").classList.toggle("hide", true);
//   }
//   document.querySelector(".search-result.active").classList.toggle("active", false);
// }

function selectCountry(country) {

  let parsedCountry = parseProvincesAndCountries([country.fullId]);

  // console.log('selectCountry country', country);
  // console.log('selectCountry parse', parsedCountry);

  if (isAddMode) {

    //console.log(country);
    changeGridMode(true);

    let countries = getCountries();
    //console.log('countries', countries);

    if (country.isProvince) {
      countries.push(country.name);
    } else {
      countries.push(country.name);
    }


    if (countries.length >= MAX_LOCATIONS_GRID_MODE) {
      document.body.classList.toggle("max-locations", true);
    } else {
      document.body.classList.toggle("max-locations", false);
    }


    setCountries(countries, true);

  } else {

    updateSelectedCountry(parsedCountry[0], document.querySelector("#feature-country"));
    setCountry(country.name);
  }



  document.body.classList.toggle("search", false);
  document.body.classList.toggle("empty", false);
  hingeCountry();

}


function searchCountries(searchValue) {

  // Handle searching
  let re;
  let searchMatches = [];
  let provinceMatches = [];
  if (searchValue) {

    re = new RegExp(searchValue,"gi");

    allCountries.forEach(country => {

      let details = getCountryDetails(country.name);
      country.countryId = country.id;
      country.fullId = country.id;

      // Searching using the GISAID name, the mapped displayName, and any synonyms
      let searches = [country.name, details.displayName, ...details.synonyms];
      let searchMatch = searches.find(s => {
        return s.match(re);
      });

      if (searchMatch) {
        searchMatches.push(country);
      }
    });

    searchMatches.sort((a, b) => a.displayName.localeCompare(b.displayName));

    // console.log(searchMatches);
    // console.log(document.querySelector("#country-search-results"));

    document.querySelector("#search-results").innerHTML = "";

    drawCountries(document.querySelector("#country-search-results"), searchMatches);


    for (const country in provincesByCountry) {

      let provinces = [...provincesByCountry[country].provinces, ...provincesByCountry[country].extras];

      provinces.forEach(province => {

        let details = getProvinceDetails(province);

        // Searching using the GISAID name, the mapped displayName, and any synonyms
        let searches = [province, details.displayName, ...details.synonyms];
        let searchMatch = searches.find(s => {
          return s.match(re);
        });

        if (searchMatch) {
          //provinceMatches.push(province);
          // console.log(details);
          //
          // console.log(allProvinces);
          // console.log(province);
          // console.log('province', allProvinces.find(p => p.id === getProvinceId(province)));

          let provinceDetails = allProvinces.find((p => p.id === getProvinceId(province)));
          if (provinceDetails) {

            //provinceDetails.fullId = getFullProvinceId(province);

            let id = `${ getCountryId(country) }${ PROVINCE_SEPARATOR }${ getProvinceId(province) }`;

            provinceDetails.fullId = id;
            provinceDetails.isProvince = true;
            provinceDetails.provinceId = getProvinceId(province);
            provinceDetails.countryId = getCountryId(country);
            provinceDetails.name = country + PROVINCE_SEPARATOR + province;

            provinceMatches.push(provinceDetails);





          }

        //   let id = `${ getCountryId(country) }${ PROVINCE_SEPARATOR }${ getProvinceId(province) }`;
        //
        //   let selectedClass = (countries.includes(id)) ? "selected" : "";
        //
        //   provincesHtml += `<div class="province-item" data-country="${ country }" data-province="${ province }" id="${ id }"><div class="province--shape"><img /></div><div class="province--name">${ details.displayName }</div></div>`;
        //
        //   matches++;
        //   provinceMatches++;
        }

      });

    }

    //console.log(provinceMatches);

    drawCountries(document.querySelector("#province-search-results"), provinceMatches);

    //provinceMatches = parseProvincesAndCountries(provinceMatches);

    //console.log(provinceMatches);



    document.querySelector("#search-dismiss").classList.toggle("active", true);

  } else {
    //searchMatches = [...allCountries];

    drawCountriesByRegion(countriesByRegion);

    document.querySelector("#search-dismiss").classList.toggle("active", false);

  }


}


function drawCountries(container, countries) {

  // console.log(container);

  countries = countries || [];

  let selectedCountries = getCountries();

  let resultsPlural = 's';
  if (countries.length === 1) {
    resultsPlural = '';
  }

  document.querySelector("#search-readout").innerHTML = `<span>${ countries.length.toLocaleString() }</span> result${  resultsPlural}`;

  //let container = document.querySelector("#search-results");

  let html = ``;

  countries.forEach(country => {

    let selectedClass = (selectedCountries.includes(country.name)) ? "active" : "";
    let count = country && country.sequencesCount ? country.sequencesCount : 0;

    let provinceStr = country.isProvince ? `data-province="${ country.provinceId}"` : '';

    html += `<div class="search-result ${ selectedClass } ${ country.fullId }" data-country="${ country.countryId }" ${ provinceStr }>
              <div class="search-country ${ country.id }">
                <div class="flag"><img /></div>
                <h2>${ country.displayName }</h2>
                <span class="count">${ count.toLocaleString() }</span>
              </div>
            </div>`;
  });

  container.innerHTML = html;

  // Countries
  container.querySelectorAll(".search-result[data-country]:not([data-province])").forEach(country => {
    country.addEventListener("click", () => {
      let countryId = country.getAttribute("data-country");
      let countryData = allCountries.find(c => c.id === countryId);
      selectCountry(countryData);
    });
  });

  // Provinces
  container.querySelectorAll(".search-result[data-province]").forEach(provinceDiv => {
    provinceDiv.addEventListener("click", () => {
      let country = provinceDiv.getAttribute("data-country");
      let province = provinceDiv.getAttribute("data-province");

      let fullId = `${country  }${ PROVINCE_SEPARATOR }${  province}`;
      //countries.push(`${country  }${ PROVINCE_SEPARATOR }${  province}`);
      //console.log()

      // console.log(fullId);
      // console.log('pd', parseProvincesAndCountries([fullId]));

      let provinceData = allProvinces.find(c => c.id === getProvinceId(province));
      //provinceData.name = `${country.toUpperCase() }${ PROVINCE_SEPARATOR }${  province}`;;

      // console.log(fullId, provinceData);

      selectCountry(provinceData);
    });
  });

}

function drawCountriesByRegion(countriesByRegion) {

  let selectedCountries = getCountries();

  let container = document.querySelector("#search-results");

  document.querySelector("#search-readout").innerHTML = `<span>${ allCountries.length.toLocaleString() }</span> countries and dependencies`;

  let html = ``;

  for (const region in countriesByRegion) {

    let hasSubRegions = false;
    let subRegionsHtml = ``;

    for (const subRegion in countriesByRegion[region]) {

      let hasCountries = false;
      let countriesHtml = ``;

      countriesByRegion[region][subRegion].forEach(country => {

        hasCountries = true;
        hasSubRegions = true;

        //console.log(country);

        let selectedClass = (selectedCountries.includes(country.name)) ? "active" : "";
        let count = country && country.sequencesCount ? country.sequencesCount : 0;
        let disabledClass = (count === 0) ? "disabled" : "";

        countriesHtml += `<div class="search-result ${ selectedClass } ${ disabledClass}" data-country="${ country.id }">
                            <div class="search-country ${ country.id }">
                              <div class="flag"><img /></div>
                              <h2>${ country.displayName }</h2>
                              <span class="count">${ count.toLocaleString() }</span>
                            </div>
                          </div>`;


        // Provinces
        //console.log(country);
        //console.log(provincesByCountry[country]);
        if (provincesByCountry[country.name]) {
          // console.log(provincesByCountry[country.name]);

          let provinces = [...provincesByCountry[country.name].provinces, ...provincesByCountry[country.name].extras];

          // console.log(provinces);

          provinces.forEach(province => {
            //
            let details = getProvinceDetails(province);
            // console.log(details);



            //console.log(province);

            //let id = `${ getCountryId(country.name) }${ PROVINCE_SEPARATOR }${ getProvinceId(province) }`;
            let name = `${ country.name }${ PROVINCE_SEPARATOR }${ province }`;

            let parsedProvince = parseProvincesAndCountries([name]);
            if (parsedProvince) {

              parsedProvince = parsedProvince[0];
              parsedProvince.name = name;

              let counts = allProvinces.find(p => p.id === parsedProvince.provinceId);

              let selectedClass = (selectedCountries.includes(name)) ? "active" : "";
              let count = counts && counts.sequencesCount ? counts.sequencesCount : 0;

              //let disabledClass = (count === 0) ? "disabled" : "";
              let disabledClass = "";

              countriesHtml += `<div class="search-result  ${ parsedProvince.fullId } ${ selectedClass } ${ disabledClass}" data-country="${ country.id }" data-province="${ province }">
                                  <div class="search-country ${ parsedProvince.fullId }">
                                    <div class="flag"><img /></div>
                                    <h2>${ details.displayName }</h2>
                                    <span class="count">${ count.toLocaleString() }</span>
                                  </div>
                                </div>`;

            }

          });
        }

      });

      if (hasCountries) {
        subRegionsHtml += `<div class="continent-region">
            <h4 class="continent-region-label">${ subRegion }</h4>
            <div class="country-items">
              ${ countriesHtml }
            </div>
          </div>`;
      }

    }


    if (hasSubRegions) {
      html += `<div class="continent">
                  <h3 class="continent-label">${ region }</h3>
                  <div class="continent-regions">
                    ${ subRegionsHtml }
                  </div>
                </div>`;
    }

  }


  container.innerHTML = html;

  // container.querySelectorAll(".search-result").forEach(country => {
  //   country.addEventListener("click", () => {
  //     let countryId = country.getAttribute("data-country");
  //     let countryData = allCountries.find(c => c.id === countryId);
  //     selectCountry(countryData);
  //   });
  // });


  // Countries
  container.querySelectorAll(".search-result[data-country]:not([data-province])").forEach(country => {
    country.addEventListener("click", () => {
      let countryId = country.getAttribute("data-country");
      let countryData = allCountries.find(c => c.id.toLowerCase() === countryId.toLowerCase());

      countryData.fullId = countryId;

      selectCountry(countryData);
    });
  });

  // Provinces
  container.querySelectorAll(".search-result[data-province]").forEach(provinceDiv => {
    provinceDiv.addEventListener("click", () => {
      let country = provinceDiv.getAttribute("data-country");
      let province = provinceDiv.getAttribute("data-province");

      let fullId = `${country  }${ PROVINCE_SEPARATOR }${  province}`;

      let provinceData = allProvinces.find(c => c.id === getProvinceId(province));

      provinceData.fullId = fullId;
      provinceData.isProvince = true;
      provinceData.provinceId = getProvinceId(province);
      provinceData.countryId = getCountryId(country);
      provinceData.name = country + PROVINCE_SEPARATOR + province;

      selectCountry(provinceData);
    });
  });

}

export function getCountryId(country) {
  return country.replaceAll(' ', '_').replaceAll('-', '_').replaceAll('.', '').replaceAll(`'`, '').replaceAll('é', 'e').toLowerCase();
}
export function getCountryDetails(countryKey) {

  let country = countriesConfig[countryKey];
  if (!country) {
    country = {displayName:countryKey, synonyms:[]};
  }

  return country;

}




export function getProvinceId(province) {
  return province.replace(/\s/gi, '_').replace(/-/gi, '_').replace(/\./gi, '').replace(/'/gi, '').replace(/é/gi, 'e').toLowerCase();
}

export function getProvinceDetails(provinceKey) {

  let province = provincesConfig[provinceKey];
  if (!province) {
    province = {displayName:provinceKey, synonyms:[]};
  }

  return province;

}
export function getFullProvinceId(country_province) {

  let tokens = country_province.split(PROVINCE_SEPARATOR);
  let country = tokens[0];
  let province = tokens[1];

  let id = `${ getCountryId(country) }${ PROVINCE_SEPARATOR }${ getProvinceId(province) }`;
  return id;
}


export function parseProvincesAndCountries(countries) {

  let parsedCountries = [];

  countries.forEach(country => {

    let countryKey, provinceKey;

    if (country.match(PROVINCE_SEPARATOR)) {
      let tokens = country.split(PROVINCE_SEPARATOR);
      countryKey = tokens[0];
      provinceKey = tokens[1];

      parsedCountries.push({
        country : countryKey,
        countryId : getCountryId(countryKey),
        province : provinceKey,
        provinceId : getProvinceId(provinceKey),
        fullId : getFullProvinceId(country),
        isProvince : true
      });
    } else {
      countryKey = country;

      parsedCountries.push({
        country : countryKey,
        countryId : getCountryId(countryKey),
        fullId : getCountryId(country),
        isProvince : false
      });
    }
  });

  return parsedCountries;
}
